import type { EditorHandoffDocument } from "./editor-handoff";

/**
 * Latest markdown/filename from the on-page embedded converter.
 * Used when opening the full-screen editor so edits survive the navigation.
 */
let embeddedDocument: EditorHandoffDocument | null = null;

export function setEmbeddedEditorDocument(
  document: EditorHandoffDocument | null,
): void {
  embeddedDocument = document;
}

export function getEmbeddedEditorDocument(): EditorHandoffDocument | null {
  return embeddedDocument;
}

/** Tests only. */
export function resetEmbeddedEditorDocument(): void {
  embeddedDocument = null;
}
